import { Component, OnChanges } from '@angular/core';
import { DynamicFormComponent } from '@components/dynamic-form/dynamic-form.component';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@services/admin/user.service';
import { Registry } from '@/registry.service';
import { UsedCostsForm } from '@/form-settings/used-costs-form';
import { PracticesService } from '@services/practices.service';
import { PracticeModel } from '@/models/practice.model';
import { LoggerService } from '@services/logger.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-detail-practice-used-costs-form',
  templateUrl: '../../../../../components/dynamic-form/dynamic-form.component.html',
  styleUrls: ['../../../../../components/dynamic-form/dynamic-form.component.scss'],
})
export class DetailPracticeUsedCostsFormComponent
  extends DynamicFormComponent
  implements OnChanges
{
  constructor(
    protected toastr: ToastrService,
    protected userService: UserService,
    protected practiceService: PracticesService,
  ) {
    super(toastr, userService);

    this.submitTopButton = false;
    this.submitBottomButton = true;
    this.submitButtonVisible = true;
    this.primaryButton = 'Salva';
    this.setupMeta();

    Registry.getInstance().set('DetailPracticeUsedCostsFormComponent', this);
  }

  public ngOnChanges() {
    super.ngOnChanges();

    if (Object.values(this.data).length !== 0) {
      this.setupMeta();
    }
  }

  setupMeta(): void {
    this.meta = UsedCostsForm.getMeta();
  }

  public onSubmit() {
    this.submitButtonLoading = true;
    let practice = <PracticeModel>this.form.getRawValue();
    practice = this.setupUsedCostsData(practice);

    this.practiceService.savePractice(practice).subscribe({
      next: (response) => {
        this.toastr.success('Costi usato salvati correttamente!');
        Registry.getInstance().get('PracticeDetailsComponent').data = <PracticeModel>response;

        this.submitButtonLoading = false;
      },
      error: (error) => {
        LoggerService.error('savePractice failed!');
        LoggerService.error(error);
        this.manageErrorMessages(error);
        this.submitButtonLoading = false;
        Registry.getInstance().set('saveInProgress', false);
      },
      complete: () => {
        LoggerService.log('Request done');
      },
    });
  }

  protected manageErrorMessages(error: HttpErrorResponse) {
    if (error.error && error.error.message) {
      this.toastr.error(error.error.message);
    } else {
      this.toastr.error('Si è verificato un errore durante il salvataggio dei dati');
    }
  }

  private setupUsedCostsData(practice: PracticeModel) {
    // Preserve all existing practice data
    practice = { ...this.data };

    // Update only the used costs fields with new values
    practice.speseLeggeDini = this.form.get('speseLeggeDini')?.value ?? this.data.speseLeggeDini;
    practice.speseOfficinaInterna =
      this.form.get('speseOfficinaInterna')?.value ?? this.data.speseOfficinaInterna;
    practice.speseCarrozzeria =
      this.form.get('speseCarrozzeria')?.value ?? this.data.speseCarrozzeria;
    practice.speseGommista = this.form.get('speseGommista')?.value ?? this.data.speseGommista;
    practice.speseLavaggio = this.form.get('speseLavaggio')?.value ?? this.data.speseLavaggio;
    practice.speseGaranzia = this.form.get('speseGaranzia')?.value ?? this.data.speseGaranzia;

    return practice;
  }
}
